import _ from 'lodash'

export const route = window.route
export const days = [
  {id: 1, name:'lun'},
  {id: 2, name:'mar'},
  {id: 3, name:'mer'},
  {id: 4, name:'jeu'},
  {id: 5, name:'ven'},
  {id: 6, name:'sam'},
  {id: 0, name:'dim'}
]

export const getAverageHours = () => {
  if (_.isDate(dates)) {
    return dates.toISOString()
  }
  if (_.isArray(dates)) {
    return dates.map((date) => {
      return date.toISOString()
    })
  }
  return null
}

export const getISODates = (dates) => {
  if (_.isDate(dates)) {
    return dates.toISOString()
  }
  if (_.isArray(dates)) {
    return dates.map((date) => {
      return date.toISOString()
    })
  }
  return null
}

export const getDatesFromISO = (dates) => {
  if (_.isString(dates)) {
    return new Date(dates)
  }
  if (_.isArray(dates)) {
    return dates.map((date) => {
      return new Date(date)
    })
  }
  return null
}

export const getDistance = (distance) => {
  return (distance / 1000).toFixed(1) + ' kms'
}

export const getDuration = (duration) => {
  const hours = Math.floor(duration / 60 / 60)
  const minutes = Math.floor(duration / 60) - (hours * 60)

  return (hours ? `${hours} h ` : '') + `${minutes} min`
}

export const truncate = (text, size) => {
  return _.truncate(text, {
    'length': size || 250,
    'separator': ' ',
    'omission': ' ...'
  })
}

export const getLastActive = (date) => {
  const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit'};

  if (date) {
    date = new Date(date)
    return `${date.toLocaleDateString('fr-FR', options)}`
  }
  return ''
}

export const getReadableTime = (date) => {
  const options = { hour: '2-digit', minute: '2-digit'};

  if (date) {
    date = new Date(date)
    return `${date.toLocaleTimeString('fr-FR', options)}`
  }
  return ''
}

export const getReadableDate = (date, time = true) => {
  let options
  if (time) {
    options = { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit'}
  } else {
    options = { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric'}
  }

  if (date) {
    date = new Date(date)
    return `${date.toLocaleDateString('fr-FR', options)}`
  }
  return ''
}

export const getDate = (date) => {
  if (date) {
    let sections = date.split('T')
    let parts = sections[0].split('-')
    return parts[2] + '/' + parts[1] + '/' + parts[0]
  }
  return ''
}

export const formatDate = (date) => {
  if (date) {
    let parts = date.split('/')
    return parts[2] + '-' + parts[1] + '-' + parts[0]
  }
  return ''
}

export const getRole = (type) => {
  let types = getRoles()
  if (type) {
    return _.find(types, {'id': type})
  }
  return {name: 'Aucun rôle...'}
}

export const getRoles = (type) => {
  let roles = [
    {id: 1, name:'Invité'},
    {id: 2, name:'Salarié'},
    {id: 3, name:'Ambassadeur'},
    {id: 4, name:'Administrateur'}
  ]

  if (!_.isUndefined(type)) {
    return _.filter(roles, (role) => { return role.id <= type })
  }

  return roles
}

export const getAddressType = (type) => {
  let types = getAddressTypes()

  if (typeof type === 'boolean') {
    type = type ? 1 : 0
  }

  if (!_.isUndefined(type)) {
    return _.find(types, {'id': type})
  }

  return {name: 'Aucun type...'}
}

export const getAddressTypes = () => {
  return [
    {id: 0, name:'Personnelle'},
    {id: 1, name:'Partagée'}
  ]
}

export const getRouteType = (type) => {
  let types = getRouteTypes()

  if (typeof type === 'boolean') {
    type = type ? 1 : 0
  }

  if (!_.isUndefined(type)) {
    return _.find(types, {'id': type})
  }

  return {name: 'Aucun type...'}
}

export const getRouteTypes = () => {
  return [
    {id: 0, name:'Conducteur'},
    {id: 1, name:'Passager'},
    {id: 2, name:'Conducteur et/ou Passager'}
  ]
}
